import {
  renderWebComponent,
  string2obj,
  obj2string,
  getHtmlElement,
  appendHtmlElementChild,
  removeHtmlChildren,
  setHtmlElementContent,
  parseAmount, handleRenderWalletBadge
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";
import { SubmissionListConfirmationComponent } from "./SubmissionListConfirmationComponent";

export class SubmissionListFormComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue) {
      this.props = string2obj(newValue);
      this.props.submissionList = JSON.parse(this.props.submissionList);
      this.props.graderCompanies = JSON.parse(this.props.graderCompanies);
    }
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }


  connectedCallback() {
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList) );

    // Quando l'utente avrà confermato definitivamente (e pagato) la submission list, rimuovo dall'interfaccia grafica
    // il form di compilazione della submission list e mostro il pannello con l'happy ending finale
    this.eventBus.subscribe('closed-submission-list', (submissionList) => {
      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'submission-list-form-main-content').parentNode);
      appendHtmlElementChild(this.shadowRoot, new SubmissionListConfirmationComponent({ submissionList: submissionList, user_id: this.props.user_id }));
      setHtmlElementContent(document, 'wallet_amount', parseInt(parseAmount(submissionList.user_wallet?.amount, 0)));
      handleRenderWalletBadge(submissionList.user_wallet?.amount);
    });
  }



  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList};
  }



  render() {
    const html = `
      <div class="p-0 pb-5" id="submission-list-form-main-content">
        <submission-list-header-component
          props='${obj2string({
            submissionList: this.props.submissionList,
            graderCompanies: this.props.graderCompanies,
            isMiddleman: this.props.isMiddleman
          })}'
        ></submission-list-header-component>
        
        <div class="pt-3 w-100 m-0 submission-list-form-initial-sections">
          <submission-list-type-component
            props='${obj2string({
              submissionList: this.props.submissionList
            })}'
          ></submission-list-type-component>
        </div>
        
        <div class="pt-3">
          <submission-list-content-component
            props='${obj2string({
              submissionList: this.props.submissionList
            })}'
          ></submission-list-content-component>
        </div>
        
        <div class="w-100 m-0 submission-list-form-initial-sections">
          <supplementary-item-form-component
            props='${obj2string({
              brands: this.props.allBrands,
              categories: this.props.allCategories,
              notGradableBrandsOnSleeve: this.props.notGradableBrandsOnSleeve,
              singleCardsId: this.props.singleCardsId,
              submission_list_id: this.props.submissionList.id,
              submissionList: this.props.submissionList,
            })}'
          ></supplementary-item-form-component>
            
          <submission-list-additional-services-component
            props='${obj2string({
              submissionList: this.props.submissionList,
              currentUserGenerality: this.props.currentUserGenerality,
              locale: this.props.locale
            })}'
          ></submission-list-additional-services-component>
        </div>
        
        <submission-list-summary-component
          props='${obj2string({
            submissionList: this.props.submissionList,
            locale: this.props.locale,
            currentUserGenerality: this.props.currentUserGenerality
          })}'
        ></submission-list-summary-component>
      </div>
      
      <submission-list-addresses-modal-component
        props='${obj2string({
          submissionList: this.props.submissionList,
          countries: this.props.countries,
          isMiddleman: this.props.isMiddleman,
          currentUserEmail: this.props.currentUserEmail
        })}'
      ></submission-list-addresses-modal-component>
      
      <modal-component></modal-component>
      <submission-lsit-pricing-summary-modal-component></submission-lsit-pricing-summary-modal-component>
      <success-flash-message-component></success-flash-message-component>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, submissionListsStyles]);
  }
}

window.customElements.define("submission-list-form-component", SubmissionListFormComponent);